import {useEffect} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useStepperStore} from 'store/stepper';
import {useSchema} from 'context/guest';
import {getDocumentsListAsOptions} from 'utils/docTypes';
import {FORM_NAMES} from 'utils/guestForm';
import passportIcon from 'assets/icons/passport-icon-standar.svg?no-inline';
import Select from 'components/common/Select';
import {CountriesSelect} from 'components/CountriesSelect';
import {MainButton} from 'styled/common';
import {useDocumentSelection} from 'hooks/iv/useDocumentSelection';
// import {useScannerControls} from 'context/kiosko';
import {FormTypes} from './types';
import {useInitDocumentType, useInitNationality} from './init';
import {useIVRemoteSync} from 'hooks/iv/useIVRemoteSync';
import {
  PassportIcon,
  PassportTextContainer,
  SelectsContainer,
  Text,
  Wrapper,
} from './styled';

function DocumentSelectionView() {
  useIVRemoteSync();
  const {control, watch, handleSubmit, setValue} = useForm<FormTypes>();
  const {t} = useTranslation();
  const {resetIVProcess} = useStepperStore();
  const {confirm: onConfirm, isLoading} = useDocumentSelection();
  // const {initializeScanner, isConnected} = useScannerControls();

  // useEffect(
  //   function initializeScannerOnMount() {
  //     if (isConnected) {
  //       initializeScanner();
  //     }
  //   },
  //   [initializeScanner, isConnected],
  // );

  const {
    reservationDocumentsList,
    setNationality: setGuestNationality,
    isGuestSchemaFetching,
  } = useSchema();

  const nationality = watch(FORM_NAMES.nationality);
  const documentType = watch(FORM_NAMES.document_type);
  const documentOptions = getDocumentsListAsOptions(reservationDocumentsList);

  useInitNationality({
    setValue,
  });
  useInitDocumentType({
    setValue,
    options: documentOptions,
    nationality,
  });

  useEffect(() => {
    setGuestNationality?.(nationality?.value);
  }, [nationality, setGuestNationality]);

  useEffect(() => {
    resetIVProcess();
  }, [resetIVProcess]);

  return (
    <Wrapper className="iv-document-setup-view">
      <PassportTextContainer className="iv-document-setup-view__text">
        <PassportIcon src={passportIcon} width={34} height={48} />
        <Text>{t('the_document_select_will_be_used_for_check_in_form')}</Text>
      </PassportTextContainer>
      <SelectsContainer className="iv-document-setup-view__fields">
        <Controller
          name={FORM_NAMES.nationality}
          rules={{required: t('required')}}
          control={control}
          render={({field: {onChange, ...otherFields}, fieldState: {error}}) => (
            <CountriesSelect
              label={t('country_of_nationality')}
              placeholder={t('country_of_nationality')}
              error={error?.message}
              onChange={value => {
                onChange(value);
                setValue(FORM_NAMES.document_type, null);
              }}
              {...otherFields}
            />
          )}
        />
        <br />
        {nationality && (
          <Controller
            name={FORM_NAMES.document_type}
            rules={{required: t('required')}}
            control={control}
            render={({field, fieldState: {error}}) => (
              <Select
                label={t('select_document')}
                options={documentOptions}
                placeholder={t('select_document')}
                error={error?.message}
                loading={isGuestSchemaFetching}
                {...field}
              />
            )}
          />
        )}
      </SelectsContainer>
      {nationality && documentType && (
        <MainButton
          label={t('confirm')}
          onClick={handleSubmit(onConfirm)}
          loading={isLoading}
        />
      )}
    </Wrapper>
  );
}

export {DocumentSelectionView};
